module.exports = __webpack_public_path__ + "packs/media/images/badges/bug_seeker-71680b3c7ad4c1539d5671e70fbe1f61.png";